const LOCATION_REQUIRED =
  'Please enter your City, Airport, Point of Interest, Hotel Name or U.S. Zip Code'
const DATES_REQUIRED = 'Please select valid dates'
const CHILD_AGE_REQUIRED =
  "Please enter children's age to get the best price for your group"
const TRAVELERS_PER_ROOM = 4
const ROOM_CAPACITY_ERROR =
  'Rooms accommodate up to 4 people. You may need additional rooms for your group'
const DISALLOW_INFANT_INTL_FLIGHT =
  'Priceline does not support lap infants on international flights'

const validateHotels = ({
  location,
  locationObject,
  startLocation,
  startLocationObject,
  startDate,
  endDate,
  roomCount,
  isRentalCarNeeded,
  isFlightNeeded,
  adultCount,
  childrenCount,
  childrenAges
} = {}) => {
  const errors = {}
  if (!location) {
    errors.location = LOCATION_REQUIRED
  }
  if (!isFlightNeeded && !isRentalCarNeeded) {
    if (startDate && !endDate) { // End dates cannot be empty for hotel only search
      errors.endDate = DATES_REQUIRED
    }
  } else if (!endDate) { // Any missing dates when Add a Car or Flight selected is an error
    errors.endDate = DATES_REQUIRED
  }
  if (isFlightNeeded) {
    if (!startLocation) {
      errors.startLocation = LOCATION_REQUIRED
    }
    const travelerCount = adultCount + childrenCount
    const allowedTravelerCount = Number(roomCount) * TRAVELERS_PER_ROOM
    if (allowedTravelerCount < travelerCount) {
      errors.roomCapacity = ROOM_CAPACITY_ERROR
    }
    const intlEndLocation = !!(
      locationObject &&
      typeof locationObject.countryCode === 'string' &&
      locationObject.countryCode.toUpperCase() !== 'US'
    )
    const intlStartLocation = !!(
      startLocationObject &&
      typeof startLocationObject.countryCode === 'string' &&
      startLocationObject.countryCode.toUpperCase() !== 'US'
    )
    const isInfantFound = !!(
      Array.isArray(childrenAges) && childrenAges.find(age => age === '0')
    )
    const isStartLocationWithInfant = intlStartLocation && isInfantFound
    const isEndLocationWithInfant = intlEndLocation && isInfantFound
    if (isStartLocationWithInfant || isEndLocationWithInfant) {
      errors.intlLapInfant = DISALLOW_INFANT_INTL_FLIGHT
    }
  }

  if (isFlightNeeded) {
    if (childrenCount > 0) {
      const isChildrenAgesArray = Array.isArray(childrenAges)
      const numOfValidAges = isChildrenAgesArray && childrenAges.filter(age => age >= 0)
      if (childrenCount !== numOfValidAges.length) {
        errors.childAge = CHILD_AGE_REQUIRED
      }
    }
  }

  return errors
}

export const validatePromoDeals = ({ location, startDate, endDate } = {}) => {
  const errors = {}
  if (!location) {
    errors.location = LOCATION_REQUIRED
  }
  if (!startDate) {
    errors.startDate = DATES_REQUIRED
  }
  if (startDate && !endDate) { // End dates cannot be empty for hotel only search
    errors.endDate = DATES_REQUIRED
  }
  return errors
}

export default validateHotels
